<template>
  <div class="company-profile">
    <!-- Banner 图片 -->
    <div v-if="data.bannerImage" class="banner-section">
      <img :src="data.bannerImage" alt="Banner" class="banner-image">
    </div>

    <!-- 中间内容区域：图片+文字 -->
    <div class="middle-section">
      <div class="middle-container">
        <div v-if="data.middleImage" class="middle-image-wrapper">
          <img :src="data.middleImage" alt="公司介绍" class="middle-image">
        </div>
        <div v-if="data.middleText" class="middle-text-wrapper">
          <div class="middle-text">{{ data.middleText }}</div>
        </div>
      </div>
    </div>

    <!-- 底部图片 -->
    <div v-if="data.bottomImages && data.bottomImages.length > 0" class="bottom-section">
      <div class="bottom-images">
        <img v-for="(img, index) in data.bottomImages" :key="index" :src="img" :alt="`底部图片${index + 1}`" class="bottom-image">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyProfile',
  props: {
    data: {
      type: Object,
      default: () => ({
        bannerImage: '',
        middleImage: '',
        middleText: '',
        bottomImages: []
      })
    }
  },
  methods: {
    formatText (text) {
      if (!text) return ''
      // 直接返回文本，保持原有格式
      return text
    }
  }
}
</script>

<style scoped>
.company-profile {
  width: 100%;
}

/* Banner 区域 */
.banner-section {
  width: 100%;
  height: 400px;
  margin-bottom: 40px;
}

.banner-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* 中间内容区域 */
.middle-section {
  width: 100%;
  padding: 40px 0;
}

.middle-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 40px;
  align-items: center;
}

/* PC 端：宽度自适应图片，最大 580px */
.middle-image-wrapper {
  flex: 0 0 auto;
  max-width: 580px;
  width: fit-content;
}

.middle-image {
  width: auto;
  max-width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.middle-text-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
}

.middle-text {
  color: rgba(103, 103, 103, 1);
  font-size: 20px;
  line-height: 1.8;
  text-align: justify;
  white-space: pre-line;
}

.middle-text ::v-deep p {
  margin-bottom: 16px;
}

/* 底部图片区域 */
.bottom-section {
  width: 100%;
  padding: 40px 0;
}

.bottom-images {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.bottom-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 移动端 */
@media (max-width: 768px) {
  .middle-section {
    padding: 24px 0;
  }

  .middle-container {
    flex-direction: column;
    gap: 24px;
    padding: 0 16px;
  }

  .middle-image-wrapper {
    flex: 1;
    width: 100%;
    max-width: none;
  }

  .middle-image {
    width: 100%;
  }

  .middle-text {
    font-size: 14px;
    line-height: 1.6;
  }

  .bottom-section {
    padding: 24px 16px;
  }

  .bottom-images {
    flex-direction: column;
    gap: 16px;
  }

  .bottom-image {
    width: 100%;
  }
}
</style>
